import React,{Component} from "react";
import Tab from "@material-ui/core/Tab";
import Tabs from "@material-ui/core/Tabs";
import MedicalClaimListother from "./MedicalClaimListother";
import MedicalClaimListPreviousother from "./MedicalClaimListPreviousother";
const axios = require("axios");
const ref = React.createRef();
class MedicalDetailOther extends Component{
    constructor(props)
    {
        super(props);
           this.state={value:0,tab1:"block",tab2:"none",tab3:"none"};
    }    
    render(){
        return(
            <div className="containera1">
                <br></br>
                    <div>
                        <Tabs
                            value={this.state.value}
                            textColor="inherit"
                            indicatorColor="secondary"
                            style={{marginLeft:"50px"}}
                            onChange={(event, newValue) => {if(newValue == 0) this.setState({value:newValue,tab1:"block",tab2:"none",tab3:"none"}); else if(newValue == 1) this.setState({value:newValue,tab1:"none",tab2:"block",tab3:"none" }); else this.setState({value:newValue,tab1:"none",tab2:"none",tab3:"block" });                                                            
                            }}
                        >
                        <Tab label="Current year" ></Tab> 
                        <Tab label="Previous year"></Tab>
                        </Tabs>
                    </div>
                    <div style={{display:this.state.tab1}}>
                        <MedicalClaimListother/>
                    </div>
                    <div style={{display:this.state.tab2}}>
                        <MedicalClaimListPreviousother/>
                    </div>
                    <br></br><br></br>
                </div>
    )}
}
export default MedicalDetailOther;